import { createAction } from 'redux-actions'

export const promoReportsRequest = createAction('PROMO_REPORTS_REQUEST')
export const promoReportsResponse = createAction('PROMO_REPORTS_RESPONSE')
export const promoReportsCreateRequest = createAction('PROMO_REPORTS_CREATE_REQUEST')
export const promoReportsCreateResponse = createAction('PROMO_REPORTS_CREATE_RESPONSE')
export const promoReportsUpdateRequest = createAction('PROMO_REPORTS_UPDATE_REQUEST')
export const promoReportsUpdateResponse = createAction('PROMO_REPORTS_UPDATE_RESPONSE')
export const promoReportsDeleteRequest = createAction('PROMO_REPORTS_DELETE_REQUEST')
export const promoReportsDeleteResponse = createAction('PROMO_REPORTS_DELETE_RESPONSE')
export const reportFormToggle = createAction('PROMO_REPORTS_FORM_TOGGLE')
export const usersListRequest = createAction('USERS_LIST_REQUEST')
export const usersListResponse = createAction('USERS_LIST_RESPONSE')
export const changeUserStatus = createAction('CHANGE_USER_STATUS')
export const changeUserStatusResponse = createAction('CHANGE_USER_STATUS_RESPONSE')
export const changeOrgUserStatus = createAction('CHANGE_ORG_USER_STATUS')
export const changeOrgUserStatusResponse = createAction('CHANGE_ORG_USER_STATUS_RESPONSE')
export const resendConfirmationRequest = createAction('RESEND_CONFIRMATION_REQUEST')
